import React from "react";
import { Container, Card, CardContent, Typography, Chip } from "@mui/material";
import { checkUserHasBetaAccess } from "../features/auth/Utils";

const DefaultBetaFallback = ({ featureName }) => (
  <Container maxWidth="lg" sx={{ mt: 4 }}>
    <Card>
      <CardContent>
        <Typography variant="h5" color="error">
          Beta Access Required
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          {featureName
            ? `The ${featureName} feature is currently in beta. Please ask your administrator to contact support@fruitify.co.uk for access.`
            : "This feature is currently in beta. Please ask your administrator to contact support@fruitify.co.uk for access."}
        </Typography>
      </CardContent>
    </Card>
  </Container>
);

export const BetaFeature = ({ children, featureName, fallback }) => {
  const hasBetaAccess = checkUserHasBetaAccess();

  if (!hasBetaAccess) {
    return fallback !== undefined ? (
      fallback
    ) : (
      <DefaultBetaFallback featureName={featureName} />
    );
  }

  return <>{children}</>;
};

export const useBetaAccess = () => {
  return checkUserHasBetaAccess();
};

export const BetaFeatureChip = (props) => {
  return <Chip label="Beta" color="primary" size="small" {...props} />;
};
